<template>
  <div class="text-center d-flex justify-content-center align-items-center" style="min-height:700px;">
    <div
      class="spinner-grow"
      style="width: 4rem; height: 4rem; color: #358ff7"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Preparing",
};
</script>

<style>
.ctrpreparing {
  position: absolute;
  left: 0;
  right: 290px;
  top: 500px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
</style>
